import LiffRepository from './liffRepository';
import CustomerRepository from './customerRepository';
import CouponRepository from './couponRepository';
import PointRepository from './pointRepository';
import ShopRepository from './shopRepository';
import StampCardRepository from './stampCardRepository';
import ShareCampaignRepository from './shareCampaignRepository';
import RaffleRepository from '@/repositories/raffleRepository';
import RankRepository from '@/repositories/rankRepository';
import ChannelRepository from '@/repositories/channelRepository';

export type Repositories = {
  liff: typeof LiffRepository;
  customer: typeof CustomerRepository;
  coupon: typeof CouponRepository;
  point: typeof PointRepository;
  shop: typeof ShopRepository;
  stampCard: typeof StampCardRepository;
  shareCampaign: typeof ShareCampaignRepository;
  raffle: typeof RaffleRepository;
  rank: typeof RankRepository;
  channel: typeof ChannelRepository;
};

const repositories = {
  liff: LiffRepository,
  customer: CustomerRepository,
  coupon: CouponRepository,
  point: PointRepository,
  shop: ShopRepository,
  stampCard: StampCardRepository,
  shareCampaign: ShareCampaignRepository,
  raffle: RaffleRepository,
  rank: RankRepository,
  channel: ChannelRepository,
};

export const RepositoryFactory = {
  get: (name: keyof Repositories) => repositories[name],
};
